"use client"

import { CirclePile } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `CirclePileIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const CirclePileIcon = component(Icon)({ as: CirclePile })
